import { forwardRef, FunctionComponent, ReactNode } from 'react';
import ImageGroup from '../../../ui/image-group/v2';

interface ProductPhotosProps {
  list: TProductDetail['images'];
  modalTitle?: ReactNode;
  altExtraInfo?: string;
  border?: boolean;
  expressShipping?: boolean;
  steering_wheel_side?: 'R' | 'L' | null;
  status?: string;
  isPP?: boolean;
  qtt?: number;
}

const ProductPhotos = forwardRef<HTMLElement, ProductPhotosProps>(
  (
    {
      list,
      modalTitle,
      altExtraInfo,
      border,
      expressShipping,
      steering_wheel_side,
      status,
      isPP,
      qtt,
    },
    ref
  ) => (
    <ImageGroup
      list={list}
      modalTitle={modalTitle}
      altExtraInfo={altExtraInfo}
      border={border}
      expressShipping={expressShipping}
      steering_wheel_side={steering_wheel_side}
      status={status}
      ref={ref}
      isPP={isPP}
      qtt={qtt}
    />
  )
);

ProductPhotos.displayName = 'ProductPhotos';

export default ProductPhotos;
